<template>
  <div>
    <AppHeader />
    <!-- <AppNavigation /> -->
    <SpinnerDialog v-bind="spinnerDialogData"></SpinnerDialog>
    <ConfirmationDialog v-bind="confirmationDialogData"></ConfirmationDialog>
    <InformationDialog v-bind="informationDialogData"></InformationDialog>
    <main class="container">
      <!-- COLUMN 1 -->
      <section class="column" id="column1">
        <v-app>
          <v-alert dark dismissible v-model="alert" border="left" class="alert"
            :class="{ 'alert-error': alertType == 'error', 'alert-success': alertType == 'success' }">
            {{ alertMessage }}
          </v-alert>
          <div class="row mt-5">
            <div class="col-md-6 p-4">
              <h3>Single Sign On (Chevron Internal User Only)</h3>
              <v-row>
                <v-col cols="6" sm="12" class="d-flex justify-center">
                  <Button :label="'Click here to Continue'" @onClick="onSingleLogin" :btnType="'Submit'" class="mr-4" />
                </v-col>
              </v-row>
            </div>
            <div class="col-md-6 p-1">
              <div class="login-container p-2">
                <h3>3rd Party Login</h3>
                <v-form ref="loginform">
                  <v-row no-gutters dense>
                    <v-col v-show="loginError" cols="9" sm="12" class="mx-auto">
                      <p class="text-danger">
                        Invalid username or password
                      </p>
                    </v-col>
                    <v-col cols="9" sm="12" class="mx-auto">
                      <TextField :label="'Username'" v-model="username" />
                    </v-col>
                    <v-col v-if="!forgotPasswordClicked" cols="9" sm="12" class="mx-auto">
                      <v-text-field dense outlined v-model="password"
                        :append-icon="showPasswordHint ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPasswordHint ? 'text' : 'password'" label="Password"
                        @click:append="showPasswordHint = !showPasswordHint"></v-text-field>
                    </v-col>
                    <v-col v-else cols="9" sm="12" class="mx-auto">
                      <v-text-field dense outlined v-model="verificationCode" :type="'text'" label="OTP"
                        :disabled="otpsenttime === null"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="4" class="d-flex justify-start">
                          <span v-if="!forgotPasswordClicked" class="link" @click="forgotPassword"
                            style="cursor:pointer; color:#1976d2; text-decoration:underline">
                            Forgot Password
                          </span>
                          <span v-else class="link" @click="cancelForgetPassword"
                            style="cursor:pointer; color:#1976d2; text-decoration:underline">
                            Back to login
                          </span>
                        </v-col>
                        <v-col v-if="!forgotPasswordClicked" cols="8" class="d-flex justify-end">
                          <Button :label="'Login'" @onClick="onLogin" :btnType="'Submit'" :disabled="sending"
                            class="mr-4" />
                          <Button :disabled="sending" :label="'Reset'" @onClick="onReset" :btnType="'Cancel'" />
                        </v-col>
                        <v-col v-else cols="8" class="d-flex justify-end">
                          <Button :label="'send OTP'" @onClick="sendOTP" :btnType="'Submit'"
                            :disabled="otpsenttime !== null && (Date.now() - otpsenttime < 30000)" class="mr-4" />
                          <Button :label="'Submit'" @onClick="verifyLogin" :btnType="'Submit'" :disabled="sending"
                            class="mr-4" />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
            </div>
          </div>
        </v-app>
      </section>
    </main>
    <AppFooter />
    <div id="overlay">
      <div id="overlay-outerwrap">
        <a id="overlay-close"></a>
        <div id="overlay-wrap">
          <div id="overlay-wrapinside"></div>
        </div>
      </div>
    </div>
    <ScrollToTopButton></ScrollToTopButton>
  </div>
</template>

<script>
import LayoutMixin from '@/mixins/AppLayoutMixin.vue'
import Button from '@/components/ui/form/Button.vue'
import TextField from '@/components/ui/form/TextField.vue'
import Roles from '@/utils/roles'
import MsalAuthentication from '@/msal-auth'
import CryptoJS from 'crypto-js'

// import { Keys } from '@/utils/constants'

import { accountService } from '@/services'

export default {
  components: {
    Button,
    TextField
  },
  name: 'loginLayout',
  mixins: [LayoutMixin],
  data: () => ({
    dialog: false,
    layoutClass: 'layout-12',
    username: '',
    password: '',
    showPassword: false,
    alertMessage: '',
    alert: false,
    alertType: '',
    sending: false,
    otpsenttime: null,
    loginError: false,
    showPasswordHint: false,
    forgotPasswordClicked: false,
    verificationCode: ''
  }),
  methods: {
    async onLogin() {
      this.loginError = false
      this.sending = true
      const payload = {
        username: this.username,
        password: this.password
      }
      accountService.username = this.username
      accountService.isThirdPartyUser = true
      let isNextDayOfLogin = Number(localStorage.getItem('loginDate')) !== Number(new Date().getDate())
      if (localStorage.getItem('isSessionOccupied') === 'true' && !isNextDayOfLogin) {
        this.showAlertMessage('You are already logged in on this device. If you are not logged please clear cache and reload the brower.', 'error')
        return
      }
      try {
        accountService.customLogin(payload)
          .then(response => {
            if (response.status === 200) {
              const userInfo = response.data
              const user = userInfo.contractEmployerUserDTO.user
              localStorage.setItem('user-token', response.data.authenticationToken)
              localStorage.setItem('isSessionOccupied', true)
              localStorage.setItem('loginDate', (new Date()).getDate())
              window.name = 'loggedin'
              localStorage.setItem('custom-user', CryptoJS.AES.encrypt(userInfo.contractEmployerUserDTO.username, 'secret key'))
              sessionStorage.removeItem('changePasswordKey')
              const pwdChangedDate = userInfo.contractEmployerUserDTO.passwordChangedDate

              // Check if password was changed more than 60 days ago
              if (pwdChangedDate) {
                const lastChanged = new Date(pwdChangedDate)
                const now = new Date()
                const diffDays = Math.floor((now - lastChanged) / (1000 * 60 * 60 * 24))
                if (diffDays > 60) {
                  accountService.passwordExpired = true
                } else {
                  accountService.passwordExpired = false
                }
              }
              if (user.isNewUser === true) {
                localStorage.setItem('newuser', CryptoJS.AES.encrypt(userInfo.contractEmployerUserDTO.username, 'secret key'))
                window.location.href = '/contract-employer/complete'
              } else {
                window.location.href = '/'
              }
            } else if (response.status === 204) {
              this.showAlertMessage('Your account is temporarily locked due to multiple failed login attempts. Please try again after 1 hour.', 'error')
            } else {
              this.loginError = true
              this.showAlertMessage('Invalid username or password', 'error')
            }
          }).catch(() => {
            this.loginError = true
          }).finally(() => {
            this.sending = false
          })
      } catch (error) {
        this.showAlertMessage('Unable to login, please try again later', 'error')
        this.sending = false
      }
    },

    async onSingleLogin() {
      accountService.isThirdPartyUser = false
      accountService.username = ''
      accountService.passwordExpired = false
      accountService.forgotPassword = false

      localStorage.removeItem('isSessionOccupied')
      localStorage.removeItem('loginDate')
      sessionStorage.removeItem('api_token_redirect_started')

      try {
        await MsalAuthentication.initialize()
        MsalAuthentication.login()
      } catch (error) {
        this.showAlertMessage('Unable to start SSO login', 'error')
      }
    },
    forgotPassword() {
      this.forgotPasswordClicked = true
      this.message = ''
      this.password = ''
    },
    cancelForgetPassword() {
      this.forgotPasswordClicked = false
      this.message = ''
      this.verificationCode = ''
    },
    onCheckUserType() {
      this.sending = true
      accountService.getUserRole(this.username)
        .then(response => {
          if (response.status === 200) {
            const data = response.data
            if (data.roleName === Roles.LCE && !data.name.includes('@chevron')) {
              this.showPassword = true
              // if (data.isNewUser === true) {
              //   // localStorage.setItem('newuser', data.name)
              //   // this.$router.go('/contract-employer/complete/')
              // } else {
              //   this.showPassword = true
              // }
            } else {
              MsalAuthentication.login()
            }
          } else {
            this.showAlertMessage('Invalid username', 'error')
          }

          this.sending = false
        })
    },
    onReset() {
      this.username = ''
      this.password = ''
    },
    sendOTP() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      accountService.username = this.username
      if (!emailPattern.test(this.username)) {
        this.showAlertMessage('Please enter a valid email address.', 'error')
      } else {
        accountService.sendVerificationCode(this.username).then(response => {
          if (response.status === 200) {
            sessionStorage.setItem('changePasswordKey', response.data)
            this.otpsenttime = Date.now()
          } else if (response.status === 204) {
            this.showAlertMessage('Your account is temporarily locked due to multiple failed login attempts. Please try again after 1 hour.', 'error')
          } else if (response.status === 203) {
            this.showAlertMessage('username does not exist', 'error')
          } else {
            this.showAlertMessage('Invalid username', 'error')
          }
        })
      }
    },
    verifyLogin() {
      let isNextDayOfLogin = Number(localStorage.getItem('loginDate')) !== Number(new Date().getDate())
      if (localStorage.getItem('isSessionOccupied') === 'true' && !isNextDayOfLogin) {
        this.showAlertMessage('You are already logged in on this device. If you are not logged please clear cache and reload the brower.', 'error')
        return
      }
      if (!(Number.isInteger(Number(this.verificationCode)) &&
        Number(this.verificationCode) >= 1000 &&
        Number(this.verificationCode) <= 9999)) {
        this.showAlertMessage('Invalid OTP', 'error')
      } else {
        let sessionKey1 = sessionStorage.getItem('changePasswordKey')
        const payload = {
          username: this.username,
          sessionKey: sessionKey1,
          verificationCode: this.verificationCode
        }
        accountService.verifyCode(payload).then(response => {
          const userInfo = response.data
          const user = userInfo.contractEmployerUserDTO.user
          accountService.forgotPassword = true
          accountService.isThirdPartyUser = true
          localStorage.setItem('isSessionOccupied', true)
          localStorage.setItem('loginDate', (new Date()).getDate())
          window.name = 'loggedin'
          localStorage.setItem('user-token', response.data.authenticationToken)
          localStorage.setItem('custom-user', CryptoJS.AES.encrypt(userInfo.contractEmployerUserDTO.username, 'secret key'))
          localStorage.setItem('forgotPassword', true)

          window.location.href = '/'
        }).catch(() => {
          this.showAlertMessage('Invalid username or OTP')
        })
      }
    },
    showAlertMessage(message, type) {
      this.alertMessage = message
      this.alert = true
      this.alertType = type
    },
    onConfirm() {
      this.dialog = false
      localStorage.setItem('acceptedTC', true)
    },
    onCancel() {
      this.dialog = false
    }
  },
  mounted() {
    this.dialog = false
  },
  beforeMount() {
    // AdalAuthentication.initialize().then(() => AdalAuthentication.signIn())
    // MsalAuthentication.initialize()
    // const isLoggedIn = MsalAuthentication.isAuthenticated()
    // console.log('is login? ', isLoggedIn)
    // MsalAuthentication.acquireToken().then(res => {
    //   console.log(res)
    // }).catch(error => {
    //   if (isLoggedIn) {
    //     MsalAuthentication.login()
    //   }
    //   console.log(error)
    // })
  }
}
</script>

<style scoped>
.tc-dialog,
.v-dialog {
  background: #fff !important;
}

.tc-header {
  display: block;
  font-size: 1rem;
  text-align: center !important;
  font-family: "GothamBold", Arial, sans-serif;
}

.confrim {
  color: #fff;
  background-color: #0066b2 !important;
  font-family: "GothamBold", Arial, sans-serif;
}

.cancel {
  color: #fff;
  background-color: #dc3545 !important;
  font-family: "GothamBold", Arial, sans-serif;
}

.alert {
  position: fixed;
  z-index: 9999;
  top: 5px;
  min-width: 50%;
}

.alert-success {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
}

.alert-error {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}

.login-container {
  border: 1px silver solid;
  border-radius: 5px;
}

/* main{
  background: url('../../assets/bg.svg');
} */
</style>
